export const comments_4180334 = {"data":{"data":[],"links":{}}}